import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DossierService } from 'src/app/services/dossier.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import saveAs from 'file-saver';
import { ViewerDataService } from '../viewer-data.service';
import { RequestStatuses, StatusEnum } from 'src/app/constants/status.enum';
import { ViewerModalService } from '../viewer-modal.service';
import { PerformedActionRejectModal } from '../modals/perform-action-reject.modal/perform-action-reject.modal';
import { DocumentActor } from 'src/app/models/actors';
import { ActorActionsApiClient } from 'src/app/services/api-clients/actor-actions.api-client';
import { StringHelper } from 'src/app/directives/string-helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-viewer-sub-header',
  templateUrl: './viewer-sub-header.component.html'
})
export class ViewerSubHeaderComponent {
  // Start button Wiggler 
  wiggleStartButton = true;
  /**
   * We can only wiggle when enabled AND no modals open
   */
  get isWiggleAllowed(): boolean {
    return this.wiggleStartButton && !this.ngbModal.hasOpenModals()
  }
  // we use this for the StartButton Text
  startButtonClicked = false;


  @Input() scrollPosition!: number;
  @Output() startNextAction = new EventEmitter();
  @Output() actionSummary = new EventEmitter();
  translations: any = <any>{};

  currentDocumentId!: string;
  actorHasAction: boolean = false;

  requestStatus!: StatusEnum;
  currentActor!: DocumentActor;
  stringHelper = new StringHelper();

  constructor(private dossierService: DossierService,
    private authenticationService: AuthenticationService,
    private viewerDataService: ViewerDataService,
    private viewerModalService: ViewerModalService,
    private actorActionsApiClient: ActorActionsApiClient,
    private ngbModal: NgbModal
  ) {
    this.viewerDataService.getExpectedRequestStatus$().subscribe((requestStatus: StatusEnum) => {
      this.requestStatus = requestStatus;
    });
    this.viewerDataService.getCurrentActor$().subscribe(currentActor => {
      this.currentActor = currentActor;
    });

    this.viewerDataService.letUsWiggle$.subscribe((wiggleBaby) => {
      this.wiggleStartButton = wiggleBaby;
    });

  }
  get showRejectOption(): boolean {
    return this.requestStatus && RequestStatuses.ThatAreActorPending.includes(this.requestStatus);
  }
  get showPreviewDownloadOption(): boolean {
    return this.requestStatus && RequestStatuses.ThatAreActorPending.includes(this.requestStatus);
  }



  logOut() {
    this.authenticationService.logout();
  }

  public startActions(): void {
    this.startButtonClicked = true;
    this.viewerDataService.letUsWiggle$.next(false);
    this.viewerDataService.navigateThroughActions$.next(true);
    this.startNextAction.emit()
  }

  /**
   * Opens the modal that allows Rejection, and handles the Result
   * @returns 
   */
  public openRejectModal() {
    let rejectionModal = this.viewerModalService.openActorReject();
    if (!rejectionModal) {
      // couldnt open
      return;
    }
    (rejectionModal.componentInstance as PerformedActionRejectModal).rejectedWithReason.subscribe((rejectionReason) => {
      // we always parsed this:
      let parsedRejectionReason = this.stringHelper.ReplaceRNToBr(rejectionReason);
      // Grab the Associated Actor and Reject:
      let requestGuid = this.viewerDataService.get_RequestGuid;
      this.actorActionsApiClient.Reject(requestGuid, this.currentActor?.id, parsedRejectionReason).subscribe({
        next: () => {
          // display the rejected modal:
          this.viewerModalService.OpenRejected(parsedRejectionReason)
        }
      });
    });
  }
  public openActionSummaryModal(): void {
    this.viewerModalService.OpenActionSummary();
  }

  public downloadReviewCopy() {
    let requestGuid = this.viewerDataService.get_RequestGuid;
    this.dossierService.downloadReviewcopy(requestGuid).subscribe({
      next: (data: any) => {
        let filename = data.headers.get("Content-Disposition").replace("attachment; filename=", "");
        saveAs(data.body, filename);
      }
    });
  }
}